import { render, staticRenderFns } from "./ApartmentExpressView.vue?vue&type=template&id=5b2c65d1&scoped=true"
import script from "./ApartmentExpressView.vue?vue&type=script&lang=js"
export * from "./ApartmentExpressView.vue?vue&type=script&lang=js"
import style0 from "./ApartmentExpressView.vue?vue&type=style&index=0&id=5b2c65d1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c65d1",
  null
  
)

export default component.exports